<template>
    <v-app>
        <v-card  flat height="40px">
            <v-layout>
                <v-flex ml-3 mt-2>
                    <img src="@/assets/kiosk_logo.png" height="25">
                </v-flex>
            </v-layout>
        </v-card>
        <v-container>
            <v-card>
                <v-card-title>
                    ติดตามสถานะสินค้า
                    <!-- <v-btn @click="test"></v-btn> -->
                </v-card-title>
                <v-card-text>
                    <v-layout justify-center>
                        <v-flex lg6 sm10 xs9 text-right>
                            <v-text-field v-model="trackNo" label="ระบุหมายเลขโทรศัพท์,เลขที่ SO,เลขที่ PO" single-line outlined
                            color="orange accent-3" ref="trackNo" @keypress.enter="getTrack"></v-text-field>
                        </v-flex>
                        <v-flex xs1 text-left>
                            <v-btn text fab color="orange accent-3" @click="getTrack">
                                <v-icon large>mdi-magnify</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <br>

                    <!-- แสดง Progress -->
                    <v-progress-linear v-if="searchData" height="10px" color="orange accent-3" 
                    indeterminate></v-progress-linear>

                    <!-- แสดงกรณียังไม่ถึงวันส่ง -->
                    <v-layout v-if="showWarningDelivery">
                        <v-flex text-center>
                            <v-icon color="red">mdi-close-circle</v-icon>
                            <strong><font color="red">สินค้าของท่านจะจัดส่งในวันที่ {{msgDateDelivery}} กรุณาลองใหม่อีกครั้ง</font></strong>
                        </v-flex>
                    </v-layout>

                    <!-- แสดงข้อความเมื่อไม่เจอข้อมูล -->
                    <v-layout v-if="showError">
                        <v-flex text-center>
                            <v-icon color="red">mdi-close-circle</v-icon>
                            <strong><font color="red">ไม่พบข้อมูลการจัดส่ง กรุณาลองใหม่อีกครั้ง</font></strong>
                        </v-flex>
                    </v-layout>

                    <!-- แสดง Timeline -->
                    <template v-if="showTimeline">
                        <v-layout wrap>
                            <!-- <v-label @mouseover="getImgDriver">ดูรูป</v-label> -->
                            <v-flex lg3 md3 sm4 xs12><strong>วันที่ส่งสินค้า:</strong> {{msgDateDelivery}}</v-flex>
                            <v-flex lg3 md4 sm5 xs12><strong>ชื่อคนขับ:</strong> {{driverName}} 
                                <v-icon color="indigo darken-1" @click="getImgDriver">mdi-image-search</v-icon>
                            </v-flex>
                            <v-flex lg4 md5 sm6 xs12><strong>เบอร์โทรศัพท์คนขับ:</strong> {{driverTel}}</v-flex>
                            <v-flex><strong>ทะเบียนรถ:</strong> {{regNum}}</v-flex>
                        </v-layout>
                        <br>
                        <v-divider></v-divider>
                        <v-timeline v-for="(item,i) in delivery" :key="i" dense>
                            <v-timeline-item :color="i == 0 ? 'green' : 'orange accent-4'" :icon="item.icon" fill-dot>
                                <v-card max-width="300">
                                    <v-card-title>{{item.time}} น.</v-card-title>
                                    <v-card-text>
                                        {{item.desc}}
                                    </v-card-text>
                                </v-card>
                            </v-timeline-item>
                        </v-timeline>
                    </template>

                </v-card-text>
            </v-card>

            <!-- แสดงรูปภาพคนขับรถ -->
            <v-dialog v-model="showImg" width="200">
                <v-card>
                    <v-img :src="driverImg" :lazy-src="driverImg">
                        <template v-slot:placeholder>
                            <v-layout class="fill-height ma-0" align-center justify-center>
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-layout>
                        </template>
                    </v-img>
                </v-card>
            </v-dialog>

            <!-- Dialog progress -->
            <v-dialog v-model="showDialogProgress" width="unset" persistent>
                <div class="text-center">
                    <v-card>
                        <v-card-text>
                            <v-progress-circular :size="50" color="orange accent-5" indeterminate></v-progress-circular>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

            <!-- Dialog Error -->
            <v-dialog v-model="alertError" width="unset">
                <div class="text-center">
                    <v-card>
                        <v-card-text>
                            <v-layout>
                                <v-flex>
                                    <v-icon color="red" :size="45">mdi-close-circle-outline</v-icon>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    {{msgError}}
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

        </v-container>
        <!-- <v-footer padless absolute>
            <v-layout>
                <v-flex text-right>
                    <strong>v1.0.0  </strong>
                </v-flex>
            </v-layout>
        </v-footer> -->
    </v-app>
</template>
<script>
import {db,storage} from '@/firebase'
export default {
    data(){
        return{
            alertError: false,
            msgError: '',
            showDialogProgress: false,
            searchData: false,
            showWarningDelivery: false,
            msgDateDelivery: '',
            showError: false,
            showTimeline: false,
            trackNo: '',
            driverName: '',
            driverTel: '',
            regNum: '',

            showImg: false,
            driverImg: '',

            delivery: [],
        }
    },
    methods:{

        test(){
            db.collection("driver").add({
                driverCode: "29",
                driverName: "พรมงคล ขุนคงมี",
                password: "0029",
                tel: "063-378-3311"
            })
            .then(()=>{
                alert("Success.")
            })
            // db.collection("driver").where("driverCode", "==", "").get()
            // .then(query=>{
            //     query.forEach(doc=>{
            //         let data = doc.data()
                    
            //     })
            // })
        },

        getTrack(){
            let app = this
            this.delivery = []
            this.showTimeline = false
            this.searchData = true
            this.showError = false
            this.showWarningDelivery = false
            let nowDate = new Date().toISOString().substr(0,10)
            let dateDelivery = ''
            db.collection("deliveryTimeline").where("custTel", "==", app.trackNo).where("status", "==", "Y").get()
            .then(query=>{
                if(!query.docs[0]){
                    db.collection("deliveryTimeline").where("trackNo", "==", app.trackNo).where("status", "==", "Y").get()
                    .then(querySO=>{
                        if(!querySO.docs[0]){
                            db.collection("deliveryTimeline").where("poNo", "==", app.trackNo).where("status", "==", "Y").get()
                            .then(queryPO=>{
                                if(!queryPO.docs[0]){
                                    app.searchData = false
                                    app.showError = true
                                }
                                else{
                                    let dateClose = ''
                                    queryPO.forEach(doc=>{
                                        dateClose = doc.data().dateClose
                                        app.driverName = doc.data().driverName
                                        app.regNum = doc.data().regNum
                                        dateDelivery = doc.data().date
                                        app.delivery = doc.data().timeLine
                                    })
                                    db.collection("driver").where("driverName", "==", app.driverName).get()
                                    .then(queryDriver=>{
                                        queryDriver.forEach(doc=>{
                                            app.driverTel = doc.data().tel
                                        })
                                        let splitDate = dateDelivery.split("-")
                                        let date = splitDate[2].substr(0,1) == 0 ? splitDate[2].substr(1,1) : splitDate[2]
                                        let month = splitDate[1]
                                        let year = splitDate[0]*1 + 543
                                        switch(month){
                                            case '01':{
                                                month = 'มกราคม'
                                                break
                                            }
                                            case '02':{
                                                month = 'กุมภาพันธ์'
                                                break
                                            }
                                            case '03':{
                                                month = 'มีนาคม'
                                                break
                                            }
                                            case '04':{
                                                month = 'เมษายน'
                                                break
                                            }
                                            case '05':{
                                                month = 'พฤษภาคม'
                                                break
                                            }
                                            case '06':{
                                                month = 'มิถุนายน'
                                                break
                                            }
                                            case '07':{
                                                month = 'กรกฎาคม'
                                                break
                                            }
                                            case '08':{
                                                month = 'สิงหาคม'
                                                break
                                            }
                                            case '09':{
                                                month = 'กันยายน'
                                                break
                                            }
                                            case '10':{
                                                month = 'ตุลาคม'
                                                break
                                            }
                                            case '11':{
                                                month = 'พฤศจิกายน'
                                                break
                                            }
                                            case '12':{
                                                month = 'ธันวาคม'
                                                break
                                            }
                                        }
                                        app.msgDateDelivery = date + " " + month + " " + year
                                        if(dateClose){
                                            let date = new Date().toISOString().substr(0,10)
                                            let time = new Date().toTimeString().substr(0,5)
                                            let dayClose = date + " " + time
                                            if(dayClose > dateClose){
                                                db.collection("deliveryTimeline").doc(query.docs[0].id).update({
                                                    status: "N"
                                                })
                                                .then(()=>{
                                                    app.searchData = false
                                                    app.showError = true
                                                    app.$nextTick(()=>app.$refs.trackNo.focus())
                                                })
                                            }
                                            else{
                                                
                                                if(dateDelivery > nowDate){
                                                    app.delivery = []
                                                    app.searchData = false
                                                    app.showTimeline = false
                                                    app.showWarningDelivery = true
                                                }
                                                else{
                                                    app.showError = false
                                                    app.showWarningDelivery = false
                                                    if(app.delivery.length == 0){
                                                        app.searchData = false
                                                        app.showError = true
                                                    }
                                                    else{
                                                        app.searchData = false
                                                        app.showError = false
                                                        app.showTimeline = true
                                                    }
                                                } 
                                            }
                                        }
                                        else{
                                            if(dateDelivery > nowDate){
                                                app.delivery = []
                                                app.searchData = false
                                                app.showTimeline = false
                                                app.showWarningDelivery = true
                                            }
                                            else{
                                                app.showError = false
                                                app.showWarningDelivery = false
                                                if(app.delivery.length == 0){
                                                    app.searchData = false
                                                    app.showError = true
                                                }
                                                else{
                                                    app.searchData = false
                                                    app.showError = false
                                                    app.showTimeline = true
                                                }
                                            }
                                        }
                                    })
                                    
                                }
                            })
                        }
                        else{
                            let dateClose = ''
                            querySO.forEach(doc=>{
                                dateClose = doc.data().dateClose
                                app.driverName = doc.data().driverName
                                app.regNum = doc.data().regNum
                                dateDelivery = doc.data().date
                                app.delivery = doc.data().timeLine
                            })
                            db.collection("driver").where("driverName", "==", app.driverName).get()
                            .then(queryDriver=>{
                                queryDriver.forEach(doc=>{
                                    app.driverTel = doc.data().tel
                                })
                                let splitDate = dateDelivery.split("-")
                                let date = splitDate[2].substr(0,1) == 0 ? splitDate[2].substr(1,1) : splitDate[2]
                                let month = splitDate[1]
                                let year = splitDate[0]*1 + 543
                                switch(month){
                                    case '01':{
                                        month = 'มกราคม'
                                        break
                                    }
                                    case '02':{
                                        month = 'กุมภาพันธ์'
                                        break
                                    }
                                    case '03':{
                                        month = 'มีนาคม'
                                        break
                                    }
                                    case '04':{
                                        month = 'เมษายน'
                                        break
                                    }
                                    case '05':{
                                        month = 'พฤษภาคม'
                                        break
                                    }
                                    case '06':{
                                        month = 'มิถุนายน'
                                        break
                                    }
                                    case '07':{
                                        month = 'กรกฎาคม'
                                        break
                                    }
                                    case '08':{
                                        month = 'สิงหาคม'
                                        break
                                    }
                                    case '09':{
                                        month = 'กันยายน'
                                        break
                                    }
                                    case '10':{
                                        month = 'ตุลาคม'
                                        break
                                    }
                                    case '11':{
                                        month = 'พฤศจิกายน'
                                        break
                                    }
                                    case '12':{
                                        month = 'ธันวาคม'
                                        break
                                    }
                                }
                                app.msgDateDelivery = date + " " + month + " " + year
                                if(dateClose){
                                    let date = new Date().toISOString().substr(0,10)
                                    let time = new Date().toTimeString().substr(0,5)
                                    let dayClose = date + " " + time
                                    if(dayClose > dateClose){
                                        db.collection("deliveryTimeline").doc(query.docs[0].id).update({
                                            status: "N"
                                        })
                                        .then(()=>{
                                            app.searchData = false
                                            app.showError = true
                                            app.$nextTick(()=>app.$refs.trackNo.focus())
                                        })
                                    }
                                    else{
                                        
                                        if(dateDelivery > nowDate){
                                            app.delivery = []
                                            app.searchData = false
                                            app.showTimeline = false
                                            app.showWarningDelivery = true
                                        }
                                        else{
                                            app.showError = false
                                            app.showWarningDelivery = false
                                            if(app.delivery.length == 0){
                                                app.searchData = false
                                                app.showError = true
                                            }
                                            else{
                                                app.searchData = false
                                                app.showError = false
                                                app.showTimeline = true
                                            }
                                        } 
                                    }
                                }
                                else{
                                    if(dateDelivery > nowDate){
                                        app.delivery = []
                                        app.searchData = false
                                        app.showTimeline = false
                                        app.showWarningDelivery = true
                                    }
                                    else{
                                        app.showError = false
                                        app.showWarningDelivery = false
                                        if(app.delivery.length == 0){
                                            app.searchData = false
                                            app.showError = true
                                        }
                                        else{
                                            app.searchData = false
                                            app.showError = false
                                            app.showTimeline = true
                                        }
                                    }
                                }
                            })
                        }
                    })
                }
                else{
                    let dateClose = ''
                    query.forEach(doc=>{
                        dateClose = doc.data().dateClose
                        app.driverName = doc.data().driverName
                        app.regNum = doc.data().regNum
                        dateDelivery = doc.data().date
                        app.delivery = doc.data().timeLine
                    })
                    db.collection("driver").where("driverName", "==", app.driverName).get()
                    .then(queryDriver=>{
                        queryDriver.forEach(doc=>{
                            app.driverTel = doc.data().tel
                        })
                        let splitDate = dateDelivery.split("-")
                        let date = splitDate[2].substr(0,1) == 0 ? splitDate[2].substr(1,1) : splitDate[2]
                        let month = splitDate[1]
                        let year = splitDate[0]*1 + 543
                        switch(month){
                            case '01':{
                                month = 'มกราคม'
                                break
                            }
                            case '02':{
                                month = 'กุมภาพันธ์'
                                break
                            }
                            case '03':{
                                month = 'มีนาคม'
                                break
                            }
                            case '04':{
                                month = 'เมษายน'
                                break
                            }
                            case '05':{
                                month = 'พฤษภาคม'
                                break
                            }
                            case '06':{
                                month = 'มิถุนายน'
                                break
                            }
                            case '07':{
                                month = 'กรกฎาคม'
                                break
                            }
                            case '08':{
                                month = 'สิงหาคม'
                                break
                            }
                            case '09':{
                                month = 'กันยายน'
                                break
                            }
                            case '10':{
                                month = 'ตุลาคม'
                                break
                            }
                            case '11':{
                                month = 'พฤศจิกายน'
                                break
                            }
                            case '12':{
                                month = 'ธันวาคม'
                                break
                            }
                        }
                        app.msgDateDelivery = date + " " + month + " " + year
                        if(dateClose){
                            let date = new Date().toISOString().substr(0,10)
                            let time = new Date().toTimeString().substr(0,5)
                            let dayClose = date + " " + time
                            if(dayClose > dateClose){
                                db.collection("deliveryTimeline").doc(query.docs[0].id).update({
                                    status: "N"
                                })
                                .then(()=>{
                                    app.searchData = false
                                    app.showError = true
                                    app.$nextTick(()=>app.$refs.trackNo.focus())
                                })
                            }
                            else{
                                
                                if(dateDelivery > nowDate){
                                    app.delivery = []
                                    app.searchData = false
                                    app.showTimeline = false
                                    app.showWarningDelivery = true
                                }
                                else{
                                    app.showError = false
                                    app.showWarningDelivery = false
                                    if(app.delivery.length == 0){
                                        app.searchData = false
                                        app.showError = true
                                    }
                                    else{
                                        app.searchData = false
                                        app.showError = false
                                        app.showTimeline = true
                                    }
                                } 
                            }
                        }
                        else{
                            if(dateDelivery > nowDate){
                                app.delivery = []
                                app.searchData = false
                                app.showTimeline = false
                                app.showWarningDelivery = true
                            }
                            else{
                                app.showError = false
                                app.showWarningDelivery = false
                                if(app.delivery.length == 0){
                                    app.searchData = false
                                    app.showError = true
                                }
                                else{
                                    app.searchData = false
                                    app.showError = false
                                    app.showTimeline = true
                                }
                            }
                        }
                    })
                }
            })
        },

        // แสดงรูปภาพคนขับรถ
        getImgDriver(){
            this.showDialogProgress = true
            db.collection("driver").where("driverName", "==", this.driverName).get()
            .then(query=>{
                query.forEach(doc=>{
                    if(doc.data().img){
                        let img = doc.data().img
                        storage.ref(img).getDownloadURL()
                        .then(url=>{
                            this.driverImg = url
                            this.showDialogProgress = false
                            this.showImg = true
                        })
                    }
                    else{
                        this.showDialogProgress = false
                        this.msgError = "ไม่มีรูปคนขับรถ"
                        this.alertError = true
                        setTimeout(()=>{
                            this.alertError = false
                        },1500)
                    }
                })
            })
        }
    },
    mounted(){
        this.$refs.trackNo.focus()
    }
}
</script>